import { render, staticRenderFns } from "./viewCourse.vue?vue&type=template&id=4fb90c83&scoped=true&"
import script from "./viewCourse.vue?vue&type=script&lang=js&"
export * from "./viewCourse.vue?vue&type=script&lang=js&"
import style0 from "./viewCourse.vue?vue&type=style&index=0&id=4fb90c83&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb90c83",
  null
  
)

export default component.exports